export default __webpack_public_path__ + "static/media/36I-120292_-43611_0.aaf54853.jpg";